import { render, staticRenderFns } from "./AppTaskReview.vue?vue&type=template&id=732c972a&scoped=true"
import script from "./AppTaskReview.vue?vue&type=script&lang=js"
export * from "./AppTaskReview.vue?vue&type=script&lang=js"
import style0 from "./AppTaskReview.vue?vue&type=style&index=0&id=732c972a&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "732c972a",
  null
  
)

export default component.exports